module.exports = __webpack_public_path__ + "static/media/link-change.5f6fa0ee.svg";